// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3t-0";
export var eligibilityCardNotEligible = "_3t-1";